import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const ServiceCard = ({ service }) => {
  const { icon, title, description, path, available = true } = service;
  
  return (
    <div className="relative">
      <Link 
        to={path}
        className={`block p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow ${
          !available ? 'pointer-events-none' : ''
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="text-3xl mb-4">{icon}</div>
          <h3 className="text-lg font-semibold mb-2">{title}</h3>
          <p className="text-gray-600 text-sm">{description}</p>
        </div>
      </Link>
      {!available && (
        <div className="absolute inset-0 bg-gray-100 bg-opacity-75 rounded-lg flex items-center justify-center">
          <span className="text-sm font-medium text-gray-600">Coming Soon</span>
        </div>
      )}
    </div>
  );
};

ServiceCard.propTypes = {
  service: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    available: PropTypes.bool
  }).isRequired
};

export default ServiceCard;
